/*!
 * Copyright (c) REWE Digital GmbH
 */
import { h, Host } from "@stencil/core";
/**
 * Filter container component.
 */
export class VxFilterContainer {
    constructor() {
        this.handleEscapeKey = (e) => {
            if (e.key === 'Escape' && this.currentOpenFilterId) {
                this.handleCloseButton();
            }
        };
        /**
         *  Handle Click outside to close popup.
         */
        this.handleOutsideClick = (e) => {
            var _a, _b, _c, _d;
            const elementClicked = e.target;
            if (!((_a = this.filterContainer) === null || _a === void 0 ? void 0 : _a.contains(elementClicked)) &&
                !elementClicked.closest('.vx-filter-container-mobile')) {
                this.currentPage = 1;
                if (this.popupOpenTimeoutHandler !== null) {
                    clearTimeout(this.popupOpenTimeoutHandler);
                    this.popupOpenTimeoutHandler = null;
                }
                this.popupOpenTimeoutHandler = setTimeout(() => {
                    this.currentOpenFilterId = null;
                }, 600);
                if (((_b = this.currentOpenFilterId) === null || _b === void 0 ? void 0 : _b.startsWith('b')) || ((_c = this.currentOpenFilterId) === null || _c === void 0 ? void 0 : _c.startsWith('p'))) {
                    this.filterClosed.emit({ doSearch: (_d = this.currentOpenFilterId) === null || _d === void 0 ? void 0 : _d.startsWith('b') });
                }
            }
        };
        /**
         * Handles for the desktop filter button.
         */
        this.handleCloseButton = () => {
            var _a;
            const doSearch = (_a = this.currentOpenFilterId) === null || _a === void 0 ? void 0 : _a.startsWith('b');
            this.currentOpenFilterId = null;
            this.filterClosed.emit({ doSearch });
        };
        /**
         * Handles for the mobile filter button.
         */
        this.handleBrandFilterButton = () => {
            var _a;
            this.filterClosed.emit({ doSearch: (_a = this.currentOpenFilterId) === null || _a === void 0 ? void 0 : _a.startsWith('b') });
            this.handleFilterClick(null);
        };
        /**
         * Handle change on filter.
         */
        this.handleFilterValueChange = (e) => {
            const targetElement = e.target;
            switch (targetElement.type) {
                case 'checkbox':
                    this.loading = !this.currentOpenFilterId.startsWith('b');
                    this.filterChanged.emit({
                        filterId: this.currentOpenFilterId,
                        filterValueId: targetElement.name,
                    });
                    if (this.currentOpenFilterId.startsWith('b')) {
                        // that is of course fubar... but we keep this for now.
                        document.querySelectorAll(`input[type="checkbox"][name="${targetElement.name}"]`).forEach((item) => {
                            item.checked = !item.checked;
                        });
                    }
                    break;
                default:
                    console.error('Invalid filter element type (type, id, name, value)', targetElement.type, this.currentOpenFilterId, targetElement.name, targetElement.value);
            }
        };
        this.handleFilterBlur = (ev) => {
            if (!this.filterContainer.contains(ev.relatedTarget)) {
                this.currentOpenFilterId = null;
            }
        };
        /**
         * Handle filter search.
         */
        this.handleFilterSearch = (e) => {
            const searchInput = e.target;
            this.searchInputValue = searchInput.value;
        };
        /**
         * Calc active filter count.
         */
        this.calcActiveFilterCount = () => {
            var _a;
            let activeCount = 0;
            for (const filter of this.filter) {
                if ((filter.id.startsWith('b') || filter.id.startsWith('p')) && ((_a = filter.options) === null || _a === void 0 ? void 0 : _a.length)) {
                    // Only for Checkbox Inputs (Bool) add switch for more types later
                    for (const option of filter.options) {
                        if (option.selected)
                            activeCount++;
                    }
                }
            }
            return activeCount;
        };
        this.deleteAllButtonLabel = 'Alles löschen';
        this.buttonHeadingLabel = 'Filtern';
        this.closeButtonLabel = 'Filter schließen';
        this.searchFilterPlaceholder = 'Suche...';
        this.showArticleLabel = 'Produkt(e) anzeigen';
        this.executeFilterLabel = 'Filter anwenden';
        this.filter = undefined;
        this.isManufacturerListing = false;
        this.hideCategoryButton = 'Weitere Filter';
        this.popupOpen = false;
        this.popupOpenTimeoutHandler = null;
        this.currentOpenFilterId = null;
        this.currentPage = 1;
        this.loading = false;
        this.isHidden = true;
        this.shouldBeToggled = false;
        this.heightOfContainer = 56;
        this.searchInputValue = undefined;
    }
    /**
     * Watch if filter update.
     */
    handleFilterPropChange() {
        this.loading = false;
    }
    /**
     * Set Body to 100% and overflow hidden to hide secondary scrollbar on overlay.
     */
    handlePopupOpen() {
        if (this.popupOpen) {
            document.body.style.height = '100%';
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.height = 'inherit';
            document.body.style.overflow = 'inherit';
        }
    }
    /**
     * Handles filter Label interaction.
     */
    handleHideCategories() {
        this.isHidden = !this.isHidden;
    }
    /**
     * Handles filter Label interaction.
     */
    handleFilterClick(filterId) {
        if (this.popupOpenTimeoutHandler !== null) {
            clearTimeout(this.popupOpenTimeoutHandler);
            this.popupOpenTimeoutHandler = null;
        }
        if (filterId !== null && this.currentOpenFilterId !== filterId) {
            this.currentOpenFilterId = filterId;
            this.currentPage = 2;
            this.isHidden = false;
            return null;
        }
        this.currentPage = 1;
        this.popupOpenTimeoutHandler = setTimeout(() => {
            this.searchInputValue = null;
            this.currentOpenFilterId = null;
        }, 600);
    }
    /**
     * Array Filter Function.
     */
    filterArray(inputValue, searchArray) {
        if (inputValue) {
            // Escape special characters in the input value
            const escapedInput = inputValue.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
            // Create a case-insensitive regular expression
            const regex = new RegExp(escapedInput, 'i');
            const regexG = new RegExp(escapedInput, 'ig');
            const filteredValues = searchArray.filter(val => regex.test(val.label));
            return filteredValues.map(value => (Object.assign(Object.assign({}, value), { label: value.label.replace(regexG, (match) => `<b>${match}</b>`) })));
        }
        return searchArray;
    }
    /**
     * Render FilterValue Set.
     */
    renderFilterValueSet(filterId) {
        const filter = this.getFilterValues(filterId);
        const preFiltered = this.filterArray(this.searchInputValue, filter.options);
        return preFiltered === null || preFiltered === void 0 ? void 0 : preFiltered.map((option) => {
            switch (filter.type) {
                case 'select':
                    if (filter.subType === 'multi') {
                        return (h("vx-checkbox", { key: option.id, label: option.label, labelAsHtml: true, name: option.id, selected: option.selected, handleChange: this.handleFilterValueChange }));
                    }
                    return null; // No Option for Single select yet
                default:
                    console.error(`Filter of type ${filter.type} (${filter.subType}) not found`);
            }
        });
    }
    /**
     * Render Filter Category Button.
     */
    renderFilterCategoryButtons(isDesktop = false) {
        var _a;
        return (_a = this.filter) === null || _a === void 0 ? void 0 : _a.map(filter => {
            var _a, _b;
            return (((_a = filter.id) === null || _a === void 0 ? void 0 : _a.startsWith('p')) ||
                (((_b = filter.id) === null || _b === void 0 ? void 0 : _b.startsWith('b')) && !this.isManufacturerListing)) && (h("div", { class: {
                    'vx-filter-container__filter': true,
                    'vx-filter-container__filter--open': (this.currentPage > 1 && this.currentOpenFilterId === filter.id),
                } }, h("button", { id: `filterCategory_${filter.id}`, class: {
                    'vx-filter-container__filter-button': true,
                }, onClick: () => this.handleFilterClick(filter.id), onFocus: () => { this.currentOpenFilterId = null; } }, filter.label), isDesktop &&
                h("div", { class: {
                        'vx-filter-container__filter-value-set': true,
                        'vx-filter-container__filter-value-set--loading': this.loading,
                    } }, this.loading && h("vx-loading-spinner", null), h("div", { class: 'vx-filter-container__filter-value-set--scroll' }, this.renderFilterValueSet(filter.id)), h("div", { class: "vx-filter-container__filter-close-button--wrapper" }, h("button", { class: "vx-filter-container__filter-close-button", onBlur: this.handleFilterBlur.bind(this), onClick: this.handleCloseButton }, this.executeFilterLabel)))));
        });
    }
    /**
     * Handle Window Resize.
     */
    handleWindowResize() {
        if ((window === null || window === void 0 ? void 0 : window.innerWidth) >= 768 && this.popupOpen) {
            this.closePopup();
        }
        if (this.filterContainer) {
            this.shouldBeToggled = this.filterContainer.offsetHeight > this.heightOfContainer;
        }
    }
    /**
     * Triggered after component load.
     */
    componentDidLoad() {
        window.addEventListener('click', this.handleOutsideClick);
    }
    /**
     * Triggered after component update.
     */
    componentDidRender() {
        this.handleWindowResize();
    }
    /**
     * Triggered after component mounted.
     */
    connectedCallback() {
        window.addEventListener('resize', this.handleWindowResize.bind(this));
        window.addEventListener('keydown', this.handleEscapeKey.bind(this));
    }
    /**
     * Triggered after component unmounted.
     */
    disconnectedCallback() {
        window.removeEventListener('click', this.handleOutsideClick);
        window.removeEventListener('keydown', this.handleEscapeKey.bind(this));
        window.removeEventListener('resize', this.handleWindowResize.bind(this));
    }
    /**
     * Close Mobile Popup.
     */
    closePopup() {
        this.popupOpen = false;
        this.currentPage = 1;
        this.currentOpenFilterId = null;
        this.searchInputValue = null;
        this.filterClosed.emit({ doSearch: true });
    }
    /**
     * Get Filter values.
     */
    getFilterValues(filterId) {
        if (this.filter && this.filter.length > 0) {
            for (const filter of this.filter) {
                if (filterId === filter.id) {
                    return filter;
                }
            }
        }
        return null;
    }
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        var _a;
        const count = this.calcActiveFilterCount();
        return (h(Host, { key: '3a171ba179bec2037fa5ba8f480eeea37efe2651' }, h("button", { key: '47dbb62aadf54db0853441fc203f2c8a2bb83329', class: 'vx-filter-container__button', onClick: () => (this.popupOpen = true) }, this.buttonHeadingLabel, (count > 0) &&
            h("div", { class: 'vx-filter-container__filter-count' }, count)), h("div", { key: '6c852954578f4316521c8589eb0e0e01217f789a', class: {
                'vx-filter-container-mobile': true,
                'vx-filter-container-mobile--open': this.popupOpen,
            } }, h("button", { key: 'dc320a6412d65517d0b9476e1a0c43666711d1ba', class: "vx-filter-container__close", onClick: () => this.closePopup() }, "Close"), h("vx-animated-multi-page-container", { key: '325129af683bd53fb0a90e6c6c22b3ff3cb5950f', currentPageNumber: this.currentPage, totalPages: 2 }, h("vx-animated-multi-page-page", { key: '64887f8d237d8c57e1447433c8b7c27a2384c05a' }, h("div", { key: 'd1f1ebd7187394af634ece0eec21b70e909331ed', slot: 'heading' }, h("div", { key: '34aad152382a062472cfd3eebf165edc3732297b', class: 'vx-filter-container__page-heading' }, this.buttonHeadingLabel), this.filter && h("vx-selected-filter", { class: "vx-filter-container__selected-filter", deleteAllButtonLabel: this.deleteAllButtonLabel, filter: this.filter })), h("div", { key: '7fa96ffa5b2525905cc04caad552b7063e981ad6', slot: 'content' }, this.renderFilterCategoryButtons()), h("vx-button", { key: 'c1c560ea0fcb6cd19769cd645668c2254f379313', raised: true, fullwidth: true, onClick: () => this.closePopup(), slot: 'footer' }, this.showArticleLabel)), h("vx-animated-multi-page-page", { key: '42c6b72dea140a380b3333036ff529e6ae7ea278' }, h("div", { key: 'c16c799ef98a7c436b226a2c91ebd0b4e06495d2', slot: 'heading' }, h("div", { key: '66e8d01579744b5cfe94c24c54ce45aafebc89e8', class: 'vx-filter-container__page-heading', onClick: () => this.handleFilterClick(null) }, '<  ', ((_a = this.getFilterValues(this.currentOpenFilterId)) === null || _a === void 0 ? void 0 : _a.label) || ''), h("div", { key: '3739ad1d9c7ac0a5877ba81a5b566d5a438c1815', class: "vx-filter-container__search-input" }, h("vx-input", { key: 'e3bef44acff4cad3bef6566ea5038af1b8b92ae4', type: 'search', name: 'filter_search', placeholder: this.searchFilterPlaceholder, inputMode: 'search', value: this.searchInputValue, handleKeyUp: this.handleFilterSearch }))), h("div", { key: 'c7d18f4bb793f26253cc295031296c53c25b9533', class: 'vx-filter-container__filter-value-set', slot: 'content' }, (this.filter && this.filter.length > 0) &&
            this.getFilterValues(this.currentOpenFilterId) &&
            (h("div", null, this.loading && h("vx-loading-spinner", null), this.renderFilterValueSet(this.currentOpenFilterId)))), h("vx-button", { key: '6ca72c8d655078adad8210c0461b5a16d67a0758', raised: true, fullwidth: true, onClick: this.handleBrandFilterButton, slot: 'footer' }, this.executeFilterLabel)))), h("div", { key: 'b2fa447e8be14cc3a3d7865b0d82e9c94ca5fe71', class: {
                'vx-filter-container-desktop': true,
                'vx-filter-container__filter-categories-hide': this.isHidden,
            } }, h("div", { key: '9f36734554913b88fc4b220411bdf1b8c33719b8', class: 'vx-filter-container-desktop', ref: (el) => {
                this.filterContainer = el;
            } }, this.renderFilterCategoryButtons(true))), this.shouldBeToggled &&
            h("div", { class: "vx-filter-container__toggle-wrapper" }, h("button", { class: {
                    'vx-filter-container__toggle-button': true,
                    'vx-filter-container__toggle-button-hide': this.isHidden,
                }, onClick: () => this.handleHideCategories() }, this.hideCategoryButton, h("svg", { class: "vx-filter-container__svg-toggle", width: '32', height: '32', viewBox: '0 0 32 32', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, h("path", { d: 'M26.6109 8.63964C25.8285 7.78679 24.5647 7.78679 23.7824 8.63964L15.9989\n                                    17.1244L8.21549 8.63963C7.43313 7.78679 6.16932 7.78679 5.38696 8.63963C4.60461\n                                    9.49248 4.60461 10.8702 5.38696 11.723L14.5947 21.7604C15.3771 22.6132 16.6409\n                                    22.6132 17.4232 21.7604L26.631 11.723C27.3933 10.892 27.3933\n                                    9.49248 26.6109 8.63964Z', fill: 'inherit' }))))));
    }
    static get is() { return "vx-filter-container"; }
    static get encapsulation() { return "scoped"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-filter-container.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-filter-container.css"]
        };
    }
    static get properties() {
        return {
            "deleteAllButtonLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Label delete all button."
                },
                "attribute": "delete-all-button-label",
                "reflect": false,
                "defaultValue": "'Alles l\u00F6schen'"
            },
            "buttonHeadingLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Label for filter button and heading."
                },
                "attribute": "button-heading-label",
                "reflect": false,
                "defaultValue": "'Filtern'"
            },
            "closeButtonLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Close Button label."
                },
                "attribute": "close-button-label",
                "reflect": false,
                "defaultValue": "'Filter schlie\u00DFen'"
            },
            "searchFilterPlaceholder": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Search Filter Placeholder."
                },
                "attribute": "search-filter-placeholder",
                "reflect": false,
                "defaultValue": "'Suche...'"
            },
            "showArticleLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Show Artikel button label."
                },
                "attribute": "show-article-label",
                "reflect": false,
                "defaultValue": "'Produkt(e) anzeigen'"
            },
            "executeFilterLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Execute filter label."
                },
                "attribute": "execute-filter-label",
                "reflect": false,
                "defaultValue": "'Filter anwenden'"
            },
            "filter": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "Filter[]",
                    "resolved": "Filter[]",
                    "references": {
                        "Filter": {
                            "location": "import",
                            "path": "@rdss/client",
                            "id": "../client/dist/index.d.ts::Filter"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The filter parameters."
                }
            },
            "isManufacturerListing": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Bool if Listing Page is manufacturer Listing."
                },
                "attribute": "is-manufacturer-listing",
                "reflect": false,
                "defaultValue": "false"
            },
            "hideCategoryButton": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The button that show more filters."
                },
                "attribute": "hide-category-button",
                "reflect": false,
                "defaultValue": "'Weitere Filter'"
            },
            "heightOfContainer": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Height of Categories container."
                },
                "attribute": "height-of-container",
                "reflect": false,
                "defaultValue": "56"
            }
        };
    }
    static get states() {
        return {
            "popupOpen": {},
            "popupOpenTimeoutHandler": {},
            "currentOpenFilterId": {},
            "currentPage": {},
            "loading": {},
            "isHidden": {},
            "shouldBeToggled": {},
            "searchInputValue": {}
        };
    }
    static get events() {
        return [{
                "method": "filterChanged",
                "name": "filterChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Triggers the new api call on filter change."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "filterClosed",
                "name": "filterClosed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get watchers() {
        return [{
                "propName": "filter",
                "methodName": "handleFilterPropChange"
            }, {
                "propName": "popupOpen",
                "methodName": "handlePopupOpen"
            }];
    }
}
//# sourceMappingURL=vx-filter-container.js.map
